<template>
  <div class="navbar-item" @click="onClick">
    <el-button v-if="item.title == activeItem" type="primary" size="mini">{{
      item.title
    }}</el-button>
    <div class="text" v-else>{{ item.title }}</div>
  </div>
</template>
<script>
export default {
  name: 'navbar-item',
  props: ['item', 'activeItem'],
  methods: {
    onClick() {
      this.$emit('onClick', this.item)
    },
  },
}
</script>
<style lang="scss" scoped>
.navbar-item {
  text-align: center;
  cursor: pointer;
  margin-left: 15px;
  .el-button {
    background-color: #29bdb9;
    border: 0;
    font-size: 14px;
    padding: 10px 20px;
    &:hover {
      background-color: rgba($color: #29bdb9, $alpha: 0.6);
    }
  }
  .text {
    color: #333;
    padding: 0px 20px;
    height: 34px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/practice/code/navbar-item.vue